<style lang="scss" scoped>
.slide-1 {
  background-image: url(../../../assets/module4/slide1/bg-01.jpg);
  background-color: #fff;
  background-size: cover;
  background-position: center;
  position: relative;
  height: calc(100% - 100px);
  padding-top: 100px;
  padding-right: 911px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.headings {
  margin-right: 190px;
}
h2 {
  color: #ed8595;
  font-size: 64px;
  text-align: right;
  &:first-of-type {
    margin-top: -50px;
  }
}
h1 {
  color: #ed8595;
  font-size: 84px;
  padding-left: 160px;
  transform: rotate(-2deg);
  transform-origin: 0% 50%;
  &:first-of-type {
    color: #aa252c;
    padding-left: 0;
    transform: rotate(-3deg);
    transform-origin: 0% 50%;
  }
}
.content {
  max-width: 760px;
}
p {
  margin: 1em auto;
  font-size: 34px;
}
</style>

<template>
  <div class="slide-1">
    <div class="headings">
      <h1 class="heading1" v-html="$t('module4.slide1.heading1')"></h1>
      <h1 class="heading2" v-html="$t('module4.slide1.heading2')"></h1>
      <h1 class="heading3" v-html="$t('module4.slide1.heading3')"></h1>
    </div>
    <img src="@/assets/module4/slide1/sophia-01.png" class="chars" />
    <div class="content">
      <p>{{ $t("module4.slide1.paragraph1") }}</p>
      <p>{{ $t("module4.slide1.paragraph2") }}</p>
      <p>{{ $t("module4.slide1.paragraph3") }}</p>
      <h2>{{ $t("module4.slide1.outro1") }}</h2>
      <h2>{{ $t("module4.slide1.outro2") }}</h2>
    </div>
  </div>
</template>

<script>
export default {
  props: ["slideIndex"]
};
</script>
